import { useEffect, useState } from 'react';
import BlogSlides from '../Components/BlogSlides';
import { useNotification } from '../Contexts/NotificationContext';

const HomeBlog = () => {
    const { setNotification } = useNotification();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await fetch('https://rometal.com.br/rometalks/wp-json/wp/v2/posts?per_page=8&_embed');
                if (response.ok) {
                    const data = await response.json();
                    setPosts(data);
                } else {
                    throw new Error('Erro ao buscar os posts');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    return <BlogSlides content={posts} title="Rometalks" loading={loading} />;
};

export default HomeBlog;
